"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var test_attributes_1 = require("@carvana/test-attributes");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var Chip_styles_1 = require("./Chip.styles");
exports.Chip = (0, react_1.forwardRef)(function (_a, forwardedRef) {
    var testId = _a.testId, _b = _a.shape, shape = _b === void 0 ? 'rectangle' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'default' : _d, icon = _a.icon, _e = _a.iconPosition, iconPosition = _e === void 0 ? 'right' : _e, _f = _a.selected, selected = _f === void 0 ? false : _f, children = _a.children, className = _a.className, buttonProps = __rest(_a, ["testId", "shape", "disabled", "size", "icon", "iconPosition", "selected", "children", "className"]);
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    return ((0, jsx_runtime_1.jsxs)(Chip_styles_1.ChipButton, __assign({}, getTestAttributes('chip', selected && 'selected'), { className: (0, classnames_1.default)((disabled && 'chip--disabled') || (selected ? 'chip--selected' : 'chip--default'), className), "data-testid": testId, type: "button", role: "button", "aria-disabled": disabled, "aria-pressed": selected, disabled: disabled, selected: selected, size: size, "$shape": shape }, buttonProps, { ref: forwardedRef }, { children: [iconPosition === 'left' && icon, children, iconPosition === 'right' && icon] })));
});
